import React, { useState, useEffect } from 'react';
import ecom from '../../Resources/project_page/placements.png';
import dbms from '../../Resources/project_page/esports.png';
import invoicer from '../../Resources/project_page/invoice.png';
import duck from '../../Resources/project_page/duckhunt.png';
import portfolio from '../../Resources/project_page/portfolio.png';
import translate from '../../Resources/project_page/translate.png';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '../../StyleSheets/Main.css'
const back = "<"
const front = ">"
const Projects = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Function to check if screen width is less than 600px
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1000);
    };

    // Set initial state and add resize listener
    handleResize();
    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const [projects, setProjects] = useState([
    {
      title: "Esports Management",
      description: "This project streamlines the management of esports events for tournaments by utilizing SQL concepts. It offers a user-friendly interface for managing gaming events, making the entire process more efficient and enjoyable.",
      technologies: "React.js, Node.js, Express.js, MySQL",
      githubLink: "https://github.com/ape-with-helmet/DBMS_miniproject",
      websiteLink: "https://dbms-miniproject-ten.vercel.app/",
      image: dbms
    },
    {
      title: "Placements Website",
      description: "A website created with the sole intention of making the placement process smooth and secure. Implements RBAC and JWT to enhance security of the app and makes use of scanning to streamline the process.",
      technologies: "React, Node.js, Express, MySQL, AWS(Database)",
      websiteLink: "https://attendance-project-one.vercel.app/login",
      image: ecom
    },
    {
      title: "Invoice Generator",
      description: "A native Windows application for Samudra Industries that streamlines invoice creation. It dynamically generates invoices using customizable pricing and product variants, all through an intuitive user interface.",
      technologies: "Python, MySQL, Inno Setup, Flask",
      githubLink: "#",
      image: invoicer
    },
    {
      title: "Duck Hunting Game",
      description: "My very first game developed in Unity while learning the basics of game development. With randomized bird speeds, each round offers a unique challenge, adding excitement to the basic mechanics.",
      technologies: "Unity, C#",
      githubLink: "https://github.com/ape-with-helmet/GameVerse-Odyssey/releases/tag/v1.0",
      image: duck
    },
    {
      title: "This Portfolio",
      description: "This website is a project into which I have poured my heart and soul. It represents a seamless blend of creativity and utility. My goal was to create an experience that is not only aesthetically pleasing but also simple and intuitive to use.",
      technologies: "React, Node.js",
      image: portfolio
    },
    {
      title: "Tulu Translator",
      description: "This translator model was developed as part of my major project. It represents a seamless blend of linguistic expertise and advanced transformer technology. My goal was to create a tool that is both accurate and efficient.",
      technologies: "Python, Machine Learning",
      githubLink: "https://github.com/ape-with-helmet/English-Tulu-translator",
      image: translate
    }
  ]);

  // Function to go to the next project set (move the first project to the end)
  const nextProjects = () => {
    setProjects((prevProjects) => {
      const newProjects = [...prevProjects];
      newProjects.push(newProjects.shift()); // Move the first project to the end
      return newProjects;
    });
  };

  // Function to go to the previous project set (move the last project to the front)
  const prevProjects = () => {
    setProjects((prevProjects) => {
      const newProjects = [...prevProjects];
      newProjects.unshift(newProjects.pop()); // Move the last project to the front
      return newProjects;
    });
  };

  return (
    <div className="projects_container" id="projects">
      <h1>Featured Projects</h1>
      <div className="project_list">
        {isMobile
          ? projects.slice(0, 1).map((project, index) => ( // Show only one project on mobile
            <div key={index} className="project_card">
              <div className="project_card_image_holder">
                <img src={project.image} alt={project.title} />
              </div>
              <div className="project_content">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <p><strong>Technologies:</strong> {project.technologies}</p>
                <div className="project_buttons">
                  {project.githubLink && (
                    <a href={project.githubLink} target="_blank" rel="noopener noreferrer">View on GitHub</a>
                  )}
                  {project.websiteLink && (
                    <a href={project.websiteLink} target="_blank" rel="noopener noreferrer">Visit Website</a>
                  )}
                </div>
              </div>
            </div>
          ))
          : projects.slice(0, 4).map((project, index) => ( // Show 4 projects on larger screens
            <div key={index} className="project_card">
              <div className="project_card_image_holder">
                <img src={project.image} alt={project.title} />
              </div>
              <div className="project_content">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <p><strong>Technologies:</strong> {project.technologies}</p>
                <div className="project_buttons">
                  {project.githubLink && (
                    <a href={project.githubLink} target="_blank" rel="noopener noreferrer">View on GitHub</a>
                  )}
                  {project.websiteLink && (
                    <a href={project.websiteLink} target="_blank" rel="noopener noreferrer">Visit Website</a>
                  )}
                </div>
              </div>
            </div>
          ))}
      </div>
      <div className="project_navigation">
        <button onClick={prevProjects} className='back_project moving_buttons'>{back}</button>
        <button onClick={nextProjects} className='front_project moving_buttons'>{front}</button>
        <div className="floating_popup projects_front_buttons">Click to view next project</div>
        <div className="floating_popup projects_back_buttons">Click to view previous project</div>
      </div>
    </div>
  );
};

export default Projects;
